import { LoaderFunction } from "react-router-dom";
import { getSearchQuery } from "../query.ts";
import {
  searchLicensesTitles,
  SearchTitleResponse,
} from "../../../../common/api/decimal/methods/search.ts";

export const searchTitlesLicenceLoader: LoaderFunction = async ({
  request,
}): Promise<SearchTitleResponse[]> => {
  const url = new URL(request.url);
  const query = getSearchQuery(url.searchParams);
  if (query) {
    const licenseResponse = await searchLicensesTitles(query);
    if (licenseResponse.data) {
      return Promise.resolve(licenseResponse.data);
    }
  }
  return Promise.resolve([]);
};
